import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteProps } from 'react-router';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';

import {
  ROUTE_ABOUT,
  ROUTE_SPORTS_UNIVERSE,
  ROUTE_TESTERS
} from '../../RouteList';
import Button, { ButtonType } from '../../components/button/button';
import Sport from './components/Sport';
import Image, { ImageType } from '../../components/image/image';
import Container from '../../components/layout/container';

import './Result.scss';
import classNames from 'classnames';
import { SPORT_ICONS_URL } from '../../constants';

@inject('routing', 'dataStore')
class Universe extends React.Component<RouteProps & any, any> {
  public render() {
    const {
      routing: { push },
      intl,
      dataStore
    } = this.props;
    const results = dataStore.getScore();

    return (
      <React.Fragment>
        <div className={classNames('c-result')}>
          <Image
            type={ImageType.resultsTitle}
            imgSrc="/images/svg/result-bord.svg"
            alt={'Title'}
            extraClasses={'c-image--bord'}
            text={intl.formatMessage(messages.intro)}
          />
          <Image
            type={ImageType.resultsHeader}
            imgSrc="/images/svg/result-foreground.svg"
            alt={'Clouds'}
            extraClasses={'c-image--foreground'}
          />
          <Image
            type={ImageType.resultsHeader}
            imgSrc="/images/svg/result-background-fine.svg"
            alt={'Clouds'}
            extraClasses={'c-image--background c-image--background-result'}
          />
        </div>
        {/* <img src="/images/svg/result-background.svg" alt="" /> */}
        <div className={classNames('c-result__buttons')}>
          <Button
            type={ButtonType.circleBack}
            onClick={() =>
              push(dataStore.isPrivate ? ROUTE_TESTERS : ROUTE_SPORTS_UNIVERSE)
            }
          />
          <Button
            type={ButtonType.circleDone}
            onClick={() => {
              dataStore.setCurrentRouteIsValid(dataStore.emailOptinValidator());
              push(ROUTE_ABOUT);
            }}
            disabled={results.length === 0}
          />
        </div>
        {results.length && (
          <h1 className="c-result__title">{`${dataStore.firstname} ${dataStore.surname}, ${dataStore.age}`}</h1>
        )}
        <Container extraClasses={'c-container--result'}>
          {results.length ? (
            results.map((result, index) => (
              <Sport
                key={index}
                place={index + 1}
                sport={result.name}
                src={`${SPORT_ICONS_URL}${result.id}.svg`}
              />
            ))
          ) : (
            <p>
              <FormattedMessage {...messages.noResult} />
            </p>
          )}
        </Container>
      </React.Fragment>
    );
  }
}

export default injectIntl(Universe);



// WEBPACK FOOTER //
// ./src/containers/result/Result.tsx